exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.view__wrapper--1e5Bb {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 100px 40px 0;\n\ttext-align: center;\n}\n\n.view__title--2KBTC {\n\tcolor: #5b6d79;\n\tfont-family: 'avenirheavy', Helvetica, Arial, sans-serif;\n\tfont-size: 22px;\n}\n\n.view__subtitle--2O5qW {\n\tcolor: #5b6d79;\n\tfont-family: 'avenirmediumoblique', Helvetica, Arial, sans-serif;\n\tfont-size: 16px;\n\tpadding-top: 20px;\n}\n\n.view__button--xMzzo {\n\twidth: 100%;\n\tmin-width: 150px;\n\tmax-width: 200px;\n\tdisplay: inline-block;\n\tpadding-top: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "view__wrapper--1e5Bb",
	"title": "view__title--2KBTC",
	"subtitle": "view__subtitle--2O5qW",
	"button": "view__button--xMzzo"
};